import React, { useEffect, useState } from "react";
import { PieChart } from "@carbon/charts-react";
import "@carbon/charts/styles.css";
import axios from "axios";
import ImageLoading from "../../components/ImageLoading";

function PieChart1({ id }) {
  const [graphData, setGraphData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [noData, setNoData] = useState(false);
  function indianNumberFormat(num) {
    if (num >= 1e7) {
      num = num / 1e7;
      return `${num.toFixed(2)} Cr`;
    } else if (num >= 1e5) {
      num = num / 1e5;
      return `${num.toFixed(2)} L`;
    } else if (num >= 1e3) {
      num = num / 1e3;
      return `${num.toFixed(2)} K`;
    }
    return num.toString();
  }
  // const data = {
  //   digital: [
  //     {
  //       asset_name: "mutual_funds",
  //       value: 44447.34,
  //     },
  //     {
  //       asset_name: "stocks",
  //       value: 167952.51,
  //     },
  //     {
  //       asset_name: "national_pension_systems",
  //       value: 58852.97,
  //     },
  //     {
  //       asset_name: "bank",
  //       value: 39923.92,
  //     },
  //   ],
  //   physical: [
  //     {
  //       asset_name: "vehicle",
  //       value: 3888405.505,
  //     },
  //   ],
  //   total: 4199582.25,
  // };

  const formatData = (data) => {
    if (data === null) return [];
    if (data?.digital?.length === 0 && data?.physical?.length === 0) return [];
    const digitalTotal = data?.digital?.reduce(
      (total, item) => total + item.value,
      0
    );
    const physicalTotal = data?.physical?.reduce(
      (total, item) => total + item.value,
      0
    );
    console.log(digitalTotal + " " + physicalTotal);
    return [
      {
        group: "Digital Assets",
        value: digitalTotal,
      },
      {
        group: "Physical Assets",
        value: physicalTotal,
      },
    ];
  };
  const fetchNetworthGraph = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/${id}/digital_vs_physical`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      if (res.data.digital_vs_physical) {
        setGraphData(res.data.digital_vs_physical);
      } else {
        setGraphData([]);
        setNoData(true);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setNoData(true);
    }
  };
  useEffect(() => {
    fetchNetworthGraph();
  }, []);
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 2,
      style: "currency",
      currency: "INR",
    });
  }

  const options = {
    title: null,
    resizable: true,
    legend: {
      alignment: "center",
    },
    color: {
      scale: {
        "Physical Assets": "#9d53f2", // Blue
        "Digital Assets": "#26aba4", // Green
      },
    },
    toolbar: false,
    tooltip: {
      valueFormatter: (tooltipValue, label) =>
        `${formatToIndianRupees(tooltipValue)}`,
    },
    height: "290px",

    pie: {
      alignment: "center",
      labels: {
        enabled: false,
      },
    },
  };
  return (
    <>
      {loading && (
        <div className="w-full h-full flex items-center justify-center ">
          <ImageLoading />
        </div>
      )}
      {noData && (
        <div className="w-full h-full flex items-center justify-center ">
          No data found
        </div>
      )}
      {!loading && !noData && (
        <div>
          <p className="text-[16px] font-semibold  ml-4 mt-[17px] mb-[10px]">
            Digital vs Physical Assets
          </p>
          <div className=" mt-0 ">
            <PieChart data={formatData(graphData)} options={options}></PieChart>
          </div>
        </div>
      )}
    </>
  );
}

export default PieChart1;
